/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 14:13:34
 */
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import styles from '../varietyManagement/varietyManagement.module.css'
import {
  printBody,
  printBodyBusiness,
} from '../../../models/approvalFormModalPrint'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getBusinessManagementDetailAsync,
  getFirstsellcompanyrecordBaseSubmitAsync,
} from './businessManagementSlice'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../../models/datetime'
const { Option } = Select

export const ApprovalFormModal = (props: {
  editTenantId?: any
  isEdit?: any
  fscrId?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [detail, setDetail] = useState<any>()

  const [printFlag, setPrintFlag] = useState(false)

  const [buttonLoading, setButtonLoading] = useState(false)

  const getDetail = (flag?: any) => {
    dispatch(
      getBusinessManagementDetailAsync({
        fscrId: props?.fscrId,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          scfyjFlag: v?.scfyjFlag == 1 ? true : false,
          gspfyjFlag: v?.gspfyjFlag == 1 ? true : false,
          yyzzfyjFlag: v?.yyzzfyjFlag == 1 ? true : false,
          khhFlag: v?.khhFlag == 1 ? true : false,
          zlbzxyFlag: v?.zlbzxyFlag == 1 ? true : false,
          sqsFlag: v?.sqsFlag == 1 ? true : false,
          yzFlag: v?.yzFlag == 1 ? true : false,
          gwdwFlag: v?.gwdwFlag == 1 ? true : false,
          licenceCategory: v?.licenceCategory
            ? v?.licenceCategory?.indexOf('经营') != -1
              ? '02'
              : '01'
            : '',
          licenceDeadline: v?.licenceDeadline
            ? moment(v?.licenceDeadline)
            : null,
          taxDeadline: v?.taxDeadline ? moment(v?.taxDeadline) : null,
          gspGmpDeadline: v?.gspGmpDeadline ? moment(v?.gspGmpDeadline) : null,
        })
        // 打印
        if (printFlag || flag) {
          const dataMain = {
            ...v,
          }
          const content = printBodyBusiness(dataMain)
          const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
          page.document.write(content) // 写入打印页面的内容
          page.print() // 打印
          page?.close()
          setPrintFlag(false)
          props.onCancel()
        }
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      setPrintFlag(false)
      getDetail()
    } else {
      form.resetFields()
      setPrintFlag(false)
    }
  }, [props.isModalVisible, props?.fscrId])

  return (
    <Modal
      className={styles.ApprovalFormModal}
      width={1000}
      title=''
      maskClosable={false}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <div className={styles.form}>
        <Form
          autoComplete='off'
          form={form}
          onFinish={(values) => {
            setButtonLoading(true)
            const params = {
              scfyjFlag: values?.scfyjFlag ? 1 : 0,
              gspfyjFlag: values?.gspfyjFlag ? 1 : 0,
              yyzzfyjFlag: values?.yyzzfyjFlag ? 1 : 0,
              khhFlag: values?.khhFlag ? 1 : 0,
              zlbzxyFlag: values?.zlbzxyFlag ? 1 : 0,
              sqsFlag: values?.sqsFlag ? 1 : 0,
              yzFlag: values?.yzFlag ? 1 : 0,
              gwdwFlag: values?.gwdwFlag ? 1 : 0,
              blxwFlag: values?.blxwFlag,
              id: detail?.id,
              other: values?.other,
              sdkcFlag: values?.sdkcFlag,
              supplierGoods: values?.supplierGoods,
              supplierRange: values?.supplierRange,
              zfwzFlag: values?.zfwzFlag,
              zlwtFlag: values?.zlwtFlag,
              sdkcOpinion: values?.sdkcOpinion,
            }
            dispatch(
              getFirstsellcompanyrecordBaseSubmitAsync({
                ...params,
              })
            )
              .then(unwrapResult)
              .then(() => {
                if (printFlag && props?.isEdit == '1') {
                  getDetail()
                } else {
                  notification.success({
                    message: '操作成功',
                  })
                  props?.onOk()
                }
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div className={styles.approvalFormTitle}>首营企业审批表</div>
          <Row
            style={{
              margin: '0 24px',
              fontSize: '14px',
            }}
          >
            <Col
              span={12}
              className={styles.inputStyle}
              style={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <Form.Item name='' label='编号'>
                <Input
                  disabled
                  style={{
                    width: '70px',
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col
              span={12}
              className={styles.inputStyle}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Form.Item name='' label='填表日期'>
                <Input disabled style={{ width: '50px' }}></Input>
                <span style={{ padding: '0 4px' }}>年</span>
                <Input disabled style={{ width: '30px' }}></Input>
                <span style={{ padding: '0 4px' }}>月</span>
                <Input disabled style={{ width: '30px' }}></Input>
                <span style={{ padding: '0 4px' }}>日</span>
              </Form.Item>
            </Col>
          </Row>
          <div
            className={styles.noBorder}
            style={{
              width: '100%',
              height: '570px',
              overflow: 'auto',
              paddingRight: '10px',
            }}
          >
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className={styles.Style30}>供货企业名称</td>
                  <td className={styles.Style30}>类别</td>
                  <td className={styles.Style10}>联系电话</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '30%',
                      border: '1px solid #333',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='concatPhone'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '30%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                    }}
                  >
                    <Form.Item name='name'>
                      <Input disabled style={{ textAlign: 'center' }}></Input>
                    </Form.Item>
                  </td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '30%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='licenceCategory'>
                      <Checkbox.Group disabled>
                        <Checkbox value={'01'}>生产</Checkbox>
                        <Checkbox value={'02'}>经营</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </td>
                  <td
                    className={styles.Style10}
                    style={{ borderBottom: 'none' }}
                  >
                    业务员
                  </td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '30%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='concatName'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className={styles.Style15}>生产/经营许可证号</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '35%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='licenceNumber'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td className={styles.Style10}>有效期</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '40%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='licenceDeadline'>
                      <DatePicker
                        placeholder=''
                        disabled
                        format={DateTimeFormatSimple}
                        onChange={() => {
                          return
                        }}
                      />
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td className={styles.Style15}>营业执照号</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '35%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='supplierTaxNo'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td className={styles.Style10}>有效期</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '40%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='taxDeadline'>
                      <DatePicker
                        placeholder=''
                        disabled
                        format={DateTimeFormatSimple}
                        onChange={() => {
                          return
                        }}
                      />
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td
                    className={styles.Style15}
                    style={{ borderBottom: 'none' }}
                  >
                    GMP/GSP证书号
                  </td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '35%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                      color: '#333333',
                    }}
                  >
                    <Form.Item name='gspGmpNumber'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td
                    className={styles.Style10}
                    style={{ borderBottom: 'none' }}
                  >
                    有效期
                  </td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '40%',
                      border: '1px solid #333',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='gspGmpDeadline'>
                      <DatePicker
                        placeholder=''
                        disabled
                        format={DateTimeFormatSimple}
                        onChange={() => {
                          return
                        }}
                      />
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className={styles.table}>
              <tbody>
                <tr>
                  <td style={{ width: '15%' }}>生产或经营范围(以许可证为准)</td>
                  <td
                    className={styles.inputNoStyleTwoLine}
                    style={{ width: '85%' }}
                    colSpan={5}
                  >
                    <Form.Item name='supplierRange'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '15%' }}>开户户名</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '85%' }}
                    colSpan={5}
                  >
                    <Form.Item name='accountName'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className={styles.Style15NoTopBottomBorder}>开户银行</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '25%',
                      border: '1px solid #333',
                      borderTop: 'none',
                      borderBottom: 'none',
                      textAlign: 'center',
                    }}
                  >
                    <Form.Item name='bankName'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td className={styles.Style10NoTopBottomBorder}>账号</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{
                      width: '50%',
                      borderRight: '1px solid #333',
                      textAlign: 'center',
                    }}
                    colSpan={3}
                  >
                    <Form.Item name='accountNo'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
            <table className={styles.table}>
              <tbody>
                <tr>
                  <td style={{ width: '15%' }}>拟供品种</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '85%' }}
                    colSpan={5}
                  >
                    <Form.Item name='supplierGoods'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '100%' }}
                    colSpan={5}
                  >
                    <Row>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '20%' }}
                      >
                        <Form.Item name='scfyjFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            药品/经营许可证复印件
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '10%' }}
                      >
                        <Form.Item name='gspfyjFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            GMP/GSP证书复印件
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '20%' }}
                      >
                        <Form.Item name='yyzzfyjFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            营业执照复印件和年报公示
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '10%' }}
                      >
                        <Form.Item name='khhFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            开户户名、开户银行及账号
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '20%' }}
                      >
                        <Form.Item name='zlbzxyFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            质量保证协议
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '10%' }}
                      >
                        <Form.Item name='sqsFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            授权书及销售员身份证件
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '20%' }}
                      >
                        <Form.Item name='yzFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            印章、随货同行联样式
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col
                        span={12}
                        style={{ textAlign: 'left', paddingLeft: '10%' }}
                      >
                        <Form.Item name='gwdwFlag' valuePropName='checked'>
                          <Checkbox
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            供货单位及品种相关资料
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>供货企业质量保证情况</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Row className={styles.radioStyle}>
                        <span>
                          是否已通过政府网站核实企业资质材料的真实性？
                        </span>
                        <Form.Item
                          style={{ marginLeft: '100px' }}
                          name='zfwzFlag'
                        >
                          <Radio.Group
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                      <Row className={styles.radioStyle}>
                        <span>
                          是否发生过质量问题、是否质量公告上被公告的？
                        </span>
                        <Form.Item
                          style={{ marginLeft: '100px' }}
                          name='zlwtFlag'
                        >
                          <Radio.Group
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                      <Row className={styles.radioStyle}>
                        <span>是否有信誉不良记录及其他不良行为？</span>
                        <Form.Item
                          style={{ marginLeft: '100px' }}
                          name='blxwFlag'
                        >
                          <Radio.Group
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                      <Row className={styles.radioStyle}>
                        <span>是否需要进行实地考察？</span>
                        <Form.Item
                          style={{ marginLeft: '100px' }}
                          name='sdkcFlag'
                        >
                          <Radio.Group
                            disabled={props?.isEdit == '0' ? true : false}
                          >
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                      <Row
                        style={{ lineHeight: '22px', padding: '0 20px' }}
                        className={styles.inputStyle}
                      >
                        <Form.Item
                          label='其他'
                          name='other'
                          className={styles.elseInputStyle}
                        >
                          <Input
                            disabled={props?.isEdit == '0' ? true : false}
                            style={{
                              width: '70px',
                            }}
                          ></Input>
                        </Form.Item>
                      </Row>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='考察人'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input disabled style={{ width: '30px' }}></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input disabled style={{ width: '30px' }}></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>实地考察意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputRemarkStyle}>
                      <Form.Item name='sdkcOpinion'>
                        <Input.TextArea
                          rows={3}
                          maxLength={500}
                          disabled={props?.isEdit == '0' ? true : false}
                        ></Input.TextArea>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>采购员意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='buyOpinion'>
                        <Input.TextArea rows={2} disabled></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='负责人签字'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('YYYY')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>质量负责人意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='approvalOpinion'>
                        <Input.TextArea rows={2} disabled></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='负责人签字'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format(
                                  'YYYY'
                                )
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>企业负责人意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='qualityAuditOpinion'>
                        <Input.TextArea rows={2} disabled></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='负责人签字'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('YYYY')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <span
              style={{ marginRight: '10px', lineHeight: '32px', color: 'red' }}
            >
              说明:黄色背景表示可编辑，点击右侧“保存”按钮生效
            </span>
            <Button
              type='primary'
              loading={buttonLoading}
              style={{ marginRight: '10px' }}
              onClick={() => {
                setPrintFlag(true)
                if (props?.isEdit == '0') {
                  getDetail(true)
                } else {
                  form.submit()
                }
              }}
            >
              开始打印
            </Button>
            {props?.isEdit == '0' ? (
              <></>
            ) : (
              <>
                <Button
                  type='primary'
                  loading={buttonLoading}
                  onClick={() => {
                    form.submit()
                    setPrintFlag(false)
                  }}
                  ghost
                  style={{ marginRight: '10px' }}
                >
                  保存
                </Button>
                <Button
                  type='primary'
                  ghost
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    props?.onCancel()
                  }}
                >
                  取消
                </Button>
              </>
            )}
          </Row>
        </Form>
      </div>
    </Modal>
  )
}
